import React from 'react';
import ContentFiltering from './ContentFiltering';

export function TopNavRules() {
  return <ContentFiltering />;
}

export default TopNavRules;